import axios from 'axios'
import CONSTANTS from '../constants/index'

const client = axios.create({
  baseURL: CONSTANTS.API.BASE,
  headers: {
    Accept: "application/json",
    authorization: null
  },
  timeout: 90000
});

client.interceptors.request.use((config) => {
  const headers = { authorization: config.authorization }
  config.headers = Object.assign(config.headers, headers)
  return config
}, err => {
  console.error(err)
  return Promise.reject(err)
})

client.interceptors.response.use(res => res, error => {
  console.error(error)
  return Promise.reject(error)
})
export default client